/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Bhanu Sharma",
  title: "Hi, I'm Bhanu",
  subTitle:[
  emoji("I am an AI/ML Engineer specializing in production-level LLM systems, distributed computing, and agentic framework design."),
  emoji("My background bridges advanced machine learning research and enterprise-scale engineering."),
  emoji("I am currently finalizing my MS in Bioinformatics (Data Science Focus) at Northeastern University (Dec 2026), where I maintain a 4.0 GPA with coursework centered on Deep Learning, Machine Learning, and NLP."),
  emoji("With 4+ years of scalable infrastructure experience combined with deep LLM and agentic AI capabilities, I bring a robust, deployment-ready skillset to forward-thinking AI/ML teams.")
  ],
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/sbhanu2112",
  linkedin: "https://www.linkedin.com/in/bhanusharma2112/",
  gmail: "sharma.bhan@northeastern.edu",
    // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Skills in my Arsenal",
  subTitle: "",
  skills: [
    emoji(
      "⚡ Programming Languages: Python, R, SQL, UNIX/Shell, Scala, Java, SAS"),
    emoji(
      "⚡ Libraries: Pytorch, Tensorflow, Numpy, Pyspark, Pandas, Matplotlib, ggplot2, scikit-learn"),
    emoji("⚡ AI Tools: vLLM, TRT-LLM, AIPerf, Openclaw, Zeus Energy"),
    emoji("⚡ Tools: Jupyter, Power BI, Tableau, Azure, Databricks, Snowflake, Spark, Docker, ADF, AWS, MS Office, Github"),
      emoji(
      "⚡ Skills: Machine Learning, Artificial Intelligence, NLP, Deep Learning, Benchmarking, Data Visualization, Big Data, Data Warehousing, Business Intelligence, ETL pipelines, CI/CD, Agile, Cloud")
  ],
  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "",
      fontAwesomeClassname: "fab fa-r-project"
    },
    {
      skillName: "",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "",
      fontAwesomeClassname: "fas fa-chart-bar"
    },
    {
      skillName: "",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "",
      fontAwesomeClassname: "far fa-snowflake"
    },
    {
      skillName: "",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Northeastern University",
      logo: require("./assets/images/northeasternlogo.png"),
      subHeader: "Master of Science in Bioinformatics",
      duration: "September 2024 - December 2026",
      desc: "GPA: 4.0\nRelevant Coursework: Deep Learning, Foundations of AI, Machine Learning, Statistics, Algorithms"
    },
    {
      schoolName: "Punjab Engineering College (PEC)",
      logo: require("./assets/images/peclogo.png"),
      subHeader: "Bachelor of Technology in ECE",
      duration: "August 2016 - May 2020",
      desc: "GPA: 7.7/10 \nRelevant Coursework: DBMS, Operating Systems, Data Structures Algorithms"}
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "AI Research Intern",
      company: "Dell Technologies",
      companylogo: require("./assets/images/dellLogo.png"),
      date: "Jan 2026 – June 2026",
      descBullets: [
        "Developed an LLM inference simulator that, given hardware/model specs and SLA targets, evaluates serving configs to predict throughput, latency, TTFT, and ITL within ±15% accuracy at batch sizes of 512+, giving the optimal config for a vLLM serving setup while incorporating continuous batching, parallelism, and disaggregated serving",
        "Extended the simulator to support Mixture-of-Experts (MoE) models and multiple quantization strategies, enabling efficient and cost-aware inference optimization and saving a projected 1500+ GPU hours",
        "Modeled and implemented a novel LLM inference energy and power estimator based on a roofline model of energy, achieving up to 90% accuracy"
      ]
    },
    {
      role: "Teaching Assistant",
      company: "Northeastern University",
      companylogo: require("./assets/images/northeasternlogo.png"),
      date: "Sept 2025 – Present",
      descBullets: [
        "CS 6140: Machine Learning – Supported 87+ graduate students with core ML concepts by holding weekly office hours and grading",
        "MATH 7340: Statistics for Bioinformatics – Supported 90+ graduate students with R programming and core statistical concepts with weekly office hours"
      ]
    },
    {
      role: "Data Engineer 2",
      company: "UnitedHealth Group (Optum)",
      companylogo: require("./assets/images/uhglogo.png"),
      date: "Sept 2023 – Jun 2024",
      descBullets: [
        "Designed numerous interactive dashboards using Power BI and MySQL delivering essential business insights and KPI results for 50+ clients spread across 4 departments",
        "Developed a comprehensive notification & alerting system in Python that enabled users to send and schedule SQL result sets as emails via Outlook, saving an estimated 6 hours weekly for end-users"
      ]
    },
    {
      role: "Data Engineer 1",
      company: "UnitedHealth Group (Optum)",
      companylogo: require("./assets/images/uhglogo.png"),
      date: "Aug 2020 – Aug 2023",
      descBullets: [
        "Migrated legacy ETL pipeline to Spark/Scala and Snowflake framework on Microsoft Azure, enabling a transition to a cost-efficient cloud-based platform and reducing database costs by up to 90%",
        "Redesigned on-prem ETL architecture from SAS to Spark/Scala, PySpark, and MongoDb(NoSQL) architecture hosted on Azure Databricks and Azure Data Factory allowing clients to adopt an efficient workflow handling an estimated 3TB+ of daily data",
        "Engineered a novel Data Quality checking system using Great Expectations library in Python with an accuracy of 99%"
      ]
    },
    {
      role: "Software Engineer Intern",
      company: "iTuple",
      companylogo: require("./assets/images/ituplelogo.png"),
      date: "Jan 2019 – May 2019",
      descBullets: [
        "Implemented an Identity Access and Management (IAM) System with CRUD operations using Amazon Web Services (AWS) and Node.js to streamline secure access for 100+ users"
      ]
    }
      ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Publications",
  subtitle: "",
  projects: [
    {
      image: require("./assets/images/hidden_thirst.png"),
      projectName:
        "The Hidden Thirst of AI: A Framework for Estimating Direct, Indirect, and Scarcity-Adjusted Freshwater Consumption per LLM Query",
      projectDesc: "Green, 2026, 1(2), 8.",
      footerLink: [
        {
          name: "View Paper (DOI)",
          url: "https://doi.org/10.3390/green1020008"
        }
      ]
    },
    {
      image: require("./assets/images/operational_resilience.png"),
      projectName:
        "Operational Resilience Under Carbon Constraints: A Socio-Technical Multi-Agentic Approach to Global Supply Chains",
      projectDesc: "Systems, 2026, 14(4), 374.",
      footerLink: [
        {
          name: "View Paper (DOI)",
          url: "https://doi.org/10.3390/systems14040374"
        }
      ]
    },
    {
      image: require("./assets/images/research_paper.png"),
      projectName: "Some Patterns of Sleep Quality and Daylight Savings Time Across Countries",
      projectDesc:
        "International Journal of Data Mining & Knowledge Management Process (IJDKP), 2025, 15(4).",
      footerLink: [
        {
          name: "View Paper (DOI)",
          url: "https://doi.org/10.48550/arXiv.2509.03358"
        }
        //  you can add extra buttons here.
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+1 617-560-0716",
  email_address: "sharma.bhan@northeastern.edu"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
